<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import MainLayout from "@/components/layout/MainLayout.vue";
import DeployBanner from "@/components/layout/DeployBanner.vue";

const route = useRoute();
// Public (login) and fullscreen (page builder) routes render bare — no sidebar
// or app header. Auth is still enforced for fullscreen via the router guard.
const bare = computed(() => Boolean(route.meta.public) || Boolean(route.meta.fullscreen));
</script>

<template>
  <RouterView v-if="bare" />
  <MainLayout v-else />
  <!-- Floating deploy-progress pill — only on bare/fullscreen routes (the
       builder); portal routes show status in MainLayout's PendingChangesBar. -->
  <DeployBanner v-if="bare" />
</template>
